<template>
<!--    <div class="progress">-->
<!--      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :aria-valuenow="store.bar_length"-->
<!--           aria-valuemin="0" aria-valuemax="100" :style="'width: ' + store.bar_length"></div>-->
<!--    </div>-->
    <div class="pt-4">
    <Transition :name="store.currentTransition" mode="out-in">
      <component :is="current_question"></component>
    </Transition>
    </div>
</template>


<script setup>
import {defineAsyncComponent, computed} from "vue";
import {surveyStore} from "@/stores/store";

const store = surveyStore()

const current_question = computed(() => {
  return defineAsyncComponent(() => import("../ResultsConfirmation.vue"))
})
</script>

<style>
.next-enter {
  opacity: 0;
  transform: translate3d(400px, 0, 0);
}

.next-enter-to {
  transform: scale3d(1, 1, 1);
}

.next-enter-active,
.next-leave-active {
  transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.next-leave {
  transform: scale3d(1, 1, 1);
}

.next-leave-to {
  opacity: 0;
  transform: translate3d(-400px, 0, 0);
}

.prev-enter {
  opacity: 0;
  transform: translate3d(-400px, 0, 0);
}

.prev-enter-to {
  transform: scale3d(1, 1, 1);
}

.prev-enter-active,
.prev-leave-active {
  transition: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.prev-leave {
  transform: scale3d(1, 1, 1);
}

.prev-leave-to {
  opacity: 0;
  transform: translate3d(400px, 0, 0);
}

/* If animations are reduced at the OS level, use simpler transitions */
@media screen and (prefers-reduced-motion: reduce) {
  .next-enter {
    opacity: 0;
    transform: translate3d(100px, 0, 0);
  }

  .next-enter-active,
  .next-leave-active {
    transition: 0.5s;
  }

  .next-leave-to {
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
  }

  .prev-enter {
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
  }

  .prev-enter-active,
  .prev-leave-active {
    transition: 0.5s;
  }

  .prev-leave-to {
    opacity: 0;
    transform: translate3d(100px, 0, 0);
  }
}
</style>